import { Text } from "native-base";
import React from "react";

import MobileHeader from "@/components/molecules/MobileHeader";
import Container from "@/components/organisms/Container";
import { CompanyType } from "@/interfaces/domain/CompanyType";
import { isNativeDevice } from "@/utils/platform";

import FormLoading from "../components/FormLoading";
import { SignUpFormScreenProps } from "../types";
import Form from "./components/Form";
import { CompanyFormData } from "./schema";

type SignupCompanyMobileProps = {
  companyTypes: CompanyType[];
} & SignUpFormScreenProps<CompanyFormData>;

const SignupCompanyMobile = ({
  companyTypes,
  isLoading,
  onCancel,
  onSubmit,
}: SignupCompanyMobileProps) => {
  return (
    <Container
      overlapMaxHeight={!isNativeDevice}
      Header={<MobileHeader title="Cadastro" onBackPress={onCancel} />}>
      <Text fontSize="2xl" py="6">
        Cadastro de Empresa
      </Text>
      {isLoading ? (
        <FormLoading numberOfFields={6} />
      ) : (
        <Form companyTypes={companyTypes} onCancel={onCancel} onSubmit={onSubmit} />
      )}
    </Container>
  );
};

export default SignupCompanyMobile;
